import { Injectable } from "@angular/core"
import { ApiService } from "app/shared/services/api.service"
import { flatMap, Observable } from "rxjs"
import { SendGridDomainResponse } from "./models/v1sendgrid"
import { MessageServiceResponse } from "./models/twillio"
import { RequestLogBody } from "./models/log"
import { IMessageService } from "@shared/models/messageservice"
import { AuthenticationService } from "@shared/services/authentication.service"
import { API_BROADCAST } from "app/app-settings"

const API = "broadcast/"

@Injectable({
  providedIn: "root",
})
export class BroadcastApiService {
  constructor(private apiService: ApiService, private authService: AuthenticationService) {}

  public V1SendGrid = {
    getDomains: (id: string): Observable<SendGridDomainResponse[]> => this.apiService.get<SendGridDomainResponse[]>(`${API}SendGrid/Organization/Domains?id=${id}`),
  }

  public Twillio = {
    getMessagingServiceByHotelId: (orgId: string, hotelId: string): Observable<MessageServiceResponse> => this.apiService.get<MessageServiceResponse>(`${API}Twillio/MessagingService/OrganizationId/${orgId}/HotelId/${hotelId}`),
    checkPhoneNumber: (phoneNumber: string): Observable<any> => this.apiService.get<any>(`${API_BROADCAST}Twillio/Check?number=${encodeURIComponent(phoneNumber)}`),
  }

  public Log = {
    postLog: (log: RequestLogBody): Observable<any> => this.apiService.post(`${API}Log`, log),
  }

  public getMessageService(): Observable<IMessageService> {
    return this.authService.getHotelPreference().pipe(
      flatMap((hotel) => {
        return this.authService.fetchHotel(hotel.Id).pipe(
          flatMap((x) => {
            return this.apiService.get(`${API_BROADCAST}Twillio/MessagingService/OrganizationId/${x.OrganizationId}/HotelId/${x.Id}`)
          })
        )
      })
    )
  }
}
